export enum PaymentStateEnum {
  PENDING = 'PENDING',
  STARTED = 'STARTED',
  FAILED = 'FAILED',
  COMPLETED = 'COMPLETED',
  CANCELLED = 'CANCELLED'
}
